<div class="container pt-3 fade-in-left">
    <div class="d-flex align-items-center justify-content-center mb-4 pe-5">
        <a (click)="back()"><div class="p-2"><i class="bi bi-chevron-left align-middle"></i></div></a>
        <div class="p-2 flex-grow-1 pl-2"><h1 class="text-dark text-center ">{{(id_perfil == 1 || id_perfil == 2 || id_perfil == 3) ? 'Mis Compras' : 'Ventas'}}</h1></div>
        <div class="p-2 pl-2 help" (click)="toggleHelp()"><i class="bi bi-info-circle"></i></div>
    </div>
    @if (helpVisible()) {
        <div class="row m-3 p-3 align-items-center" id="tooltip-pwa">
            <div class="col-auto"><i class="bi bi-info-circle" style="font-size: 1.8em;"></i></div>
            <div class="col">{{ helpText() }}</div>
            <div class="col-auto" (click)="toggleHelp()"><i class="bi bi-x-lg" style="font-size: 1.4em;"></i></div>
        </div>
    }

    <!-- Sections -->
     @if(!id_estado_orden){
        <div class="row-cols-12 m-2 mb-3">
            @if(id_perfil == 1 || id_perfil == 2 || id_perfil == 3){
                <div class="text-p p-3 pb-1">
                    <button class="btn btn-primary btn-lg mt-0 mb-3" [routerLink]="['/comercio']">Realizar una nueva compra</button>
                </div>
            }
            
            <div class="text-p p-3 pb-1">
                <h2>{{(id_perfil == 1 || id_perfil == 2 || id_perfil == 3) ? 'Compras en curso' : 'Ventas en curso'}}</h2>
            </div>
            @for (ordenComercioCurso of ordenesComercioCurso; track ordenComercioCurso.id) {
                <a [routerLink]="['/order-response-comercio', ordenComercioCurso.id]">
                    <div class="row p-2 px-4 align-items-center" >
                        <div class="col-auto"><i class="bi bi-bag"></i></div>
                        <div class="col">
                            <div class="col-12 text-title-item">Pedido #{{ordenComercioCurso.id}}</div>
                            <div class="col-12 text-detail-item">{{ordenComercioCurso.estadoOrden}} - {{ordenComercioCurso.d_date_create | date: 'dd/MM/yyyy - HH:mm'}}hs</div>
                        </div>
                        <div class="col-auto"><i class="bi bi-chevron-right"></i></div>
                    </div>
                </a>
            }
        </div>

        <div class="row-cols-12 m-2 mb-5" >
            <div class="text-p p-3 pb-1">
                <h2>{{(id_perfil == 1 || id_perfil == 2 || id_perfil == 3) ? 'Compras anteriores' : 'Ventas anteriores'}}</h2>
            </div>
            @for (ordenComercioAnterior of ordenesComercioAnteriores; track ordenComercioAnterior.id) {
                <a [routerLink]="['/order-response-comercio', ordenComercioAnterior.id]">
                    <div class="row p-2 px-4 align-items-center" [ngClass]="{'text-danger': ordenComercioAnterior.id_estado_orden == 5}">
                        <div class="col-auto"><i class="bi bi-bag"></i></div>
                        <div class="col">
                            <div class="col-12 text-title-item">Pedido #{{ordenComercioAnterior.id}}</div>
                            <div class="col-12 text-detail-item">{{ordenComercioAnterior.estadoOrden}} - {{ordenComercioAnterior.d_date_create | date: 'dd/MM/yyyy - HH:mm'}}hs</div>
                        </div>
                        <div class="col-auto"><i class="bi bi-chevron-right"></i></div>
                    </div>
                </a>
            }
            <div class="p-5"></div>
        </div>
     }

     @if(id_estado_orden === 4){
        <div class="row-cols-12 m-2 mb-3">
            <div class="text-p p-3 pb-1">
                <h2>{{(id_perfil == 1 || id_perfil == 2 || id_perfil == 3) ? 'Compras a calificar' : 'Ventas a calificar'}}</h2>
            </div>
            @for (ordenComercioFiltrada of ordenesComercioFiltradas; track ordenComercioFiltrada.id) {
                <a [routerLink]="['/review-comercio', ordenComercioFiltrada.id]">
                    <div class="row p-2 px-4 align-items-center" [ngClass]="{'text-danger': ordenComercioFiltrada.id_estado_orden == 5}">
                        <div class="col-auto"><i class="bi bi-bag"></i></div>
                        <div class="col">
                            <div class="col-12 text-title-item">Pedido #{{ordenComercioFiltrada.id}}</div>
                            <div class="col-12 text-detail-item">{{ordenComercioFiltrada.estadoOrden}} - {{ordenComercioFiltrada.d_date_create | date: 'dd/MM/yyyy - HH:mm'}}hs</div>
                        </div>
                        <div class="col-auto"><i class="bi bi-chevron-right"></i></div>
                    </div>
                </a>
            }
            <div class="p-5"></div>
        </div>
     }
</div>